import { makeAutoObservable } from 'mobx';

class ModalStore {
  modals = [];

  push = (modalID) => {
    this.modals.push(modalID);
  };

  removeModal = (modalID) => {
    const index = this.modals.indexOf(modalID);
    if (index !== -1) {
      this.modals.splice(index, 1);
    }
  };

  pop = () => {
    this.modals.pop();
  };

  constructor() {
    makeAutoObservable(this);
  }

  back() {
    this.pop();
  }

  clearStack = () => {
    this.modals = [];
  };

  showModal = (modalID) => {
    this.push(modalID);
  };

  hideModal = (modalID) => {
    this.removeModal(modalID);
  };
}

const modalStore = new ModalStore();

export default modalStore;
